import { Icon } from "./icon";

export function Spinner({size=24}: {size?: number}) {
    return (
        <Icon icon="FaSpinner" size={size} className="animate-spin" />
    )
}